import setPromiseState from '../../utils/promiseState';

const initState = {
  user: {},
  isAuthorized: false,
  isShow: false,
  isShowLogin: false,
  isShowResetPassword: false,
  successRegister: false,
  isShowSuccessResetPasswordSendEmail: false,
  registerEmail: '',
  error: {},
  promise: {
    login: setPromiseState(),
    logout: setPromiseState(),
    register: setPromiseState(),
    getUserInfo: setPromiseState(),
    resetPasswordSendEmail: setPromiseState(),
    resetPasswordCheckHash: setPromiseState(),
  },
};

export default initState;


// WEBPACK FOOTER //
// ./src/app/containers/Auth/InitState.js